/**
 * DASHBOARD-RPS-BOTTOM-SKELETON.WIDGET
 * Skeleton du bas de la page RPS (colonne des trois onglets + card de la population) affiché pendant que la
 * vue d'ensemble charge : sans lui, tout le bloc apparaissait d'un coup sous la vue d'ensemble.
 */
import Card from "@/components/card"
import Skeleton from "@/components/skeleton"
import DashboardRpsTeamsSkeletonWidget from "./dashboard-rps-teams-skeleton.widget"

export default function DashboardRpsBottomSkeletonWidget() {
  return (
    <div className="flex">
      <div className="flex flex-dcol" style={{ marginRight: "1rem", width: 152 }}>
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex flex-dcol" style={{ alignItems: "center", gap: 8, padding: "22px 0" }}>
            <Skeleton width={20} height={20} />
            <Skeleton width={70} height={11} />
          </div>
        ))}
      </div>

      <Card className="flex1">
        <DashboardRpsTeamsSkeletonWidget />
      </Card>
    </div>
  )
}
